export const KEY_DISABLE_NOTIFICATIONS = 'no-notif' as const;
export const KEY_ISOLATE_NOTIFICATION = 'isolate-notification' as const;
// useful if you have specific conditions that are very manual to trigger
// ie. trade level up notification modal requires the following:
// - transact and confirm a purchase for a trade firm that will bump
//   the firm into a different trade tier (member -> bronze, bronze -> silver, etc)
// this should only be used for testing purposes and must be used with `KEY_ISOLATE_NOTIFICATION`
export const KEY_FORCE_NOTIFICATION = 'force-notif' as const;
export const AB_TEST_MW_APP_BANNER_KEY = 'MW_APP_BANNER' as const;
